module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container content"
  }, [_c('div', {
    staticClass: "level"
  }, [_vm._m(0), _vm._v(" "), (_vm.selectedUser !== false) ? _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deselectCustomer()
      }
    }
  }, [_vm._v("\n          Cancel Order\n        ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-form"
  }, [(_vm.selectedUser === false) ? _c('div', {
    staticClass: "order-form-lookup"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_lookup = !_vm.show_lookup
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.show_lookup ? 'Hide Lookup' : 'Show Lookup') + "\n            ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_lookup),
      expression: "show_lookup"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookup_terms),
      expression: "lookup_terms"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "lookup",
      "placeholder": "Search via Customer Number, Name (Last or First and Last), Zip, Phone, or Email"
    },
    domProps: {
      "value": (_vm.lookup_terms)
    },
    on: {
      "keyup": _vm.lookup_start,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookup_terms = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.lookup_results.length > 0) ? _c('div', {
    staticClass: "lookup-results"
  }, _vm._l((_vm.lookup_results), function(user, index) {
    return _c('div', {
      staticClass: "lookup-result"
    }, [_c('button', {
      staticClass: "button is-small is-pulled-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectCustomer(user)
        }
      }
    }, [_vm._v("\n              Select\n            ")]), _vm._v("\n            " + _vm._s(_vm.companies[user.company]['name']) + "\n            -\n            "), _c('strong', [_vm._v(_vm._s(user.account_number ? user.account_number : 'N/A'))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('em', [_vm._v("\n              " + _vm._s(user.line1) + "\n              "), (user.line2) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(user.line2) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(user.city) + ", " + _vm._s(user.state) + " " + _vm._s(user.zip) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("phone")(user.phone)) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(user.email) + "\n            "), _c('br'), _vm._v(" "), _c('em', [_c('strong', [_vm._v(_vm._s(user.recipients.length))]), _vm._v(" consignees")])])
  }), 0) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "order-form-billing"
  }, [_c('h2', {
    staticClass: "title is-4"
  }, [_vm._v("Customer/Billing Details")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [(!_vm.showBillingEdit) ? _c('div', {
    class: {
      'level lookup-result no-float': true, 'colored': _vm.billing.id !== null
    }
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.companies[_vm.billing.company]['name']) + " " + _vm._s(_vm.billing.account_number))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.billing.first_name) + " " + _vm._s(_vm.billing.last_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('em', [_vm._v("\n                    " + _vm._s(_vm.billing.line1) + "\n                    "), (_vm.billing.line2) ? _c('br') : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.billing.line2) + "\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.billing.city) + ", " + _vm._s(_vm.billing.state) + " " + _vm._s(_vm.billing.zip) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm._f("phone")(_vm.billing.phone)) + "\n                  "), _c('br'), _vm._v("\n                  " + _vm._s(_vm.billing.email) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEdit()
      }
    }
  }, [_vm._v("Edit")])])])]) : _vm._e(), _vm._v(" "), (_vm.showBillingEdit) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "select",
      "label": "Company",
      "id": "company",
      "options": _vm.companies,
      "option_name": "name",
      "option_value": "initials",
      "error": _vm.billing.errors.get('company')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.company),
      callback: function($$v) {
        _vm.$set(_vm.billing, "company", $$v)
      },
      expression: "billing.company"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Customer Number",
      "id": "account_number",
      "placeholder": "Lookup customer in P&D",
      "error": _vm.billing.errors.get('account_number')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.account_number),
      callback: function($$v) {
        _vm.$set(_vm.billing, "account_number", $$v)
      },
      expression: "billing.account_number"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "First Name",
      "id": "bill_first_name",
      "error": _vm.billing.errors.get('first_name')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.first_name),
      callback: function($$v) {
        _vm.$set(_vm.billing, "first_name", $$v)
      },
      expression: "billing.first_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "id": "bill_last_name",
      "error": _vm.billing.errors.get('last_name')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.last_name),
      callback: function($$v) {
        _vm.$set(_vm.billing, "last_name", $$v)
      },
      expression: "billing.last_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Email",
      "id": "bill_email",
      "error": _vm.billing.errors.get('email')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.email),
      callback: function($$v) {
        _vm.$set(_vm.billing, "email", $$v)
      },
      expression: "billing.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('form-group', {
    ref: "bill_phone",
    attrs: {
      "type": "text",
      "label": "Phone",
      "id": "bill_phone",
      "mask": "### ### ####",
      "save-mask": false,
      "error": _vm.billing.errors.get('phone')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.phone),
      callback: function($$v) {
        _vm.$set(_vm.billing, "phone", $$v)
      },
      expression: "billing.phone"
    }
  })], 1)]), _vm._v(" "), _c('form-group', {
    ref: "autocomplete",
    attrs: {
      "type": "text",
      "label": "Street Address",
      "placeholder": "Street and number, P.O. box, c/o",
      "id": "bill_line1",
      "error": _vm.billing.errors.get('line1')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.line1),
      callback: function($$v) {
        _vm.$set(_vm.billing, "line1", $$v)
      },
      expression: "billing.line1"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "placeholder": "Apartment, suite, unit, building, floor, etc.",
      "id": "bill_line2",
      "error": _vm.billing.errors.get('line2')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.line2),
      callback: function($$v) {
        _vm.$set(_vm.billing, "line2", $$v)
      },
      expression: "billing.line2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "City",
      "id": "bill_city",
      "error": _vm.billing.errors.get('city')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.city),
      callback: function($$v) {
        _vm.$set(_vm.billing, "city", $$v)
      },
      expression: "billing.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('form-group', {
    attrs: {
      "type": "states",
      "label": "State",
      "id": "bill_state",
      "error": _vm.billing.errors.get('state')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.state),
      callback: function($$v) {
        _vm.$set(_vm.billing, "state", $$v)
      },
      expression: "billing.state"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Zip",
      "id": "bill_zip",
      "error": _vm.billing.errors.get('zip')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.zip),
      callback: function($$v) {
        _vm.$set(_vm.billing, "zip", $$v)
      },
      expression: "billing.zip"
    }
  })], 1)]), _vm._v(" "), (_vm.verify_error || _vm.address_verify) ? _c('div', [_c('strong', [_vm._v("USPS Address Verify Result:")]), _vm._v(" "), (_vm.address_verify !== null) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.address_verify.line1) + "\n                "), (_vm.address_verify.line2) ? _c('br') : _vm._e(), _vm._v("\n                " + _vm._s(_vm.address_verify.line2) + "\n                "), _c('br'), _vm._v("\n                " + _vm._s(_vm.address_verify.city) + ", " + _vm._s(_vm.address_verify.state) + " " + _vm._s(_vm.address_verify.zip) + "\n                "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.address_verify.details))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: {
      'button': true, 'is-success': _vm.addressMatch, 'is-warning': !_vm.addressMatch
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmMatch()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.addressMatch ? 'Confirm Match' : 'Update') + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.verify_error) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.verify_error.Description) + "\n                "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.acknowledgeError()
      }
    }
  }, [_vm._v("Okay.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_vm._m(3), _vm._v(" "), (_vm.showBillingEdit) ? _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.address_lookup()
      }
    }
  }, [_vm._v("\n                    Verify Address\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEdit()
      }
    }
  }, [_vm._v("\n                    Save\n                  ")])])]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Credit Card Number",
      "id": "cc_number",
      "error": _vm.billing.errors.get('cc_number')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.cc_number),
      callback: function($$v) {
        _vm.$set(_vm.billing, "cc_number", $$v)
      },
      expression: "billing.cc_number"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Credit Card Expire",
      "id": "cc_expire",
      "mask": "##/##",
      "error": _vm.billing.errors.get('cc_expire')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.cc_expire),
      callback: function($$v) {
        _vm.$set(_vm.billing, "cc_expire", $$v)
      },
      expression: "billing.cc_expire"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('form-group', {
    attrs: {
      "type": "text",
      "label": "Credit Card Security Code",
      "id": "cc_sec",
      "mask": "####",
      "error": _vm.billing.errors.get('cc_sec')
    },
    on: {
      "event": function($event) {
        return _vm.billing.listen(_vm.billing, $event)
      }
    },
    model: {
      value: (_vm.billing.cc_sec),
      callback: function($$v) {
        _vm.$set(_vm.billing, "cc_sec", $$v)
      },
      expression: "billing.cc_sec"
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "mega-hr"
  }), _vm._v(" "), _c('h2', {
    staticClass: "title is-4"
  }, [_vm._v("Consignees/Order")]), _vm._v(" "), _c('div', {
    staticClass: "order-form-recipients"
  }, [_vm._l((_vm.recipients), function(recipient, index) {
    return _c('recipient-form-part', {
      key: recipient.uuid,
      attrs: {
        "details": recipient,
        "index": index
      },
      on: {
        "remove": _vm.removeRecipient
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addRecipient
    }
  }, [_vm._v("New Consignee")]), _vm._v(" "), (_vm.availableRecipients.length > 0) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showRecipients = !_vm.showRecipients
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.showRecipients ? 'Hide User Consignees' : 'Show User Consignees') + "\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRecipients),
      expression: "showRecipients"
    }]
  }, [_c('div', {
    staticClass: "available-recipients lookup-results"
  }, _vm._l((_vm.remainingRecipients), function(recipient, index) {
    return _c('div', {
      key: recipient.id,
      staticClass: "lookup-result"
    }, [_c('button', {
      staticClass: "button is-small is-pulled-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addRecipient(recipient)
        }
      }
    }, [_vm._v("Select\n          ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(recipient.first_name) + " " + _vm._s(recipient.last_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('em', [_vm._v("\n            " + _vm._s(recipient.line1) + "\n            "), (recipient.line2) ? _c('br') : _vm._e(), _vm._v("\n            " + _vm._s(recipient.line2) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(recipient.city) + ", " + _vm._s(recipient.state) + " " + _vm._s(recipient.zip) + "\n          ")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm._f("phone")(recipient.phone)) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(recipient.email) + "\n        ")])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("New Order")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-item"
  }, [_c('h2', {
    staticClass: "title is-5"
  }, [_vm._v("Quick Lookup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_c('br'), _vm._v(" "), _c('h4', {
    staticClass: "title is-6 is-marginless"
  }, [_vm._v("Lookup instructions:")]), _vm._v("\n            Via Customer Number (min 6 digits max 8)\n            "), _c('br'), _vm._v("\n            Via Name (type the Last only, or in order of First and Last)\n            "), _c('br'), _vm._v("\n            Via Zip (must be 5 digits)\n            "), _c('br'), _vm._v("\n            Via Phone (must be 10 digits)\n            "), _c('br'), _vm._v("\n            Via Email (valid email format (e.g. test@example.domain)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eac49ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/orders/CreateOrder.vue
// module id = 498
// module chunks = 0